import React, { useMemo } from 'react';
import { gql } from '@soundxyz/gql-string';
import {
  GetAudioCollectMintableReleaseDocument,
  GetMintableReleasePlaylistDocument,
  useQuery,
} from '@graphql/reactQuery';
import { useCheckReferrableRelease } from '@hooks/useCheckReferrable';
import { useAudioController } from '@store/audio/AudioController';
import { CollectModal } from './CollectModal';

/*#__PURE__*/ gql(/* GraphQL */ `
  query GetAudioCollectMintableRelease($releaseId: UUID!) {
    release(id: $releaseId) {
      id
      ...CollectModal
      ...ReleaseReferrableInfo
    }
  }

  query GetMintableReleasePlaylist($playlistId: UUID!) {
    playlistV2(id: $playlistId) {
      id
      user {
        id
        publicAddress
      }
    }
  }
`);

export const AudioPlayerCollectModal = ({ releaseId }: { releaseId: string }) => {
  const { data: releaseInfo } = useQuery(GetAudioCollectMintableReleaseDocument, {
    variables: { releaseId },
    staleTime: 0,
  });

  const release = releaseInfo?.data.release ?? null;

  const { isShareReferrable } = useCheckReferrableRelease({
    release,
  });
  const { activePlaylistId, activePlaylistReleaseIds } = useAudioController();

  const isInActivePlaylist = useMemo(
    () => activePlaylistReleaseIds.includes(releaseId),
    [activePlaylistReleaseIds, releaseId],
  );

  const { data: playlistInfo } = useQuery(GetMintableReleasePlaylistDocument, {
    variables: !!activePlaylistId &&
      isInActivePlaylist &&
      isShareReferrable && { playlistId: activePlaylistId },
    staleTime: 0,
  });
  const playlistUserAddress = playlistInfo?.data.playlistV2?.user.publicAddress;

  if (!release) return null;

  const playlistReferral =
    isInActivePlaylist && activePlaylistId && playlistUserAddress
      ? { playlistId: activePlaylistId, playlistUserAddress }
      : null;

  return (
    <CollectModal
      release={release}
      playlistReferral={playlistReferral}
      collectButtonSource="Audio Player"
    />
  );
};
